import { createUseStyles } from 'react-jss'
import { lightGrey, backgroundGrey } from '../../../../../../styles/const/colors'
import { transitionShort } from '../../../../../../styles/const/common'

export default createUseStyles({
  muteButton: {
    padding: 5,
    borderRadius: '50%',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 30,
    height: 30,
    backgroundColor: backgroundGrey,
    border: `2px solid ${lightGrey}`,
    transition: transitionShort,
    cursor: 'pointer',
    '& svg': {
      height: 16,
      width: 16
    },

    '&:hover': {
      boxShadow: '0 1px 5px 2px rgba(0,0,0,.15)'
    }
  }
})
